import React, { useEffect } from 'react';
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import Tile from '../Tile';
import { getSessionStorage, setSessionStorage } from '../../../utils/storage';
import { LOT_NEXT_PREV_KEY } from '../../../services/artdbweb/lot';
import { getAllLots } from '../../../redux/selectors/dbEntities';
import { getLotsViewFormat } from '../../../redux/selectors/preferences';
import A18n from '../../common/A18n';

const List = ({ data: { ails = [], idlots = [], md5Page, md5, md5Query, analyticClickFrom, access, reloadDocument, withSelectLot } }) => {
  const lots = useSelector(getAllLots);
  const lotsViewFormat = useSelector(getLotsViewFormat);

  useEffect(() => {
    if (!isEmpty(idlots) && !isEmpty(lots)) {
      const search = getSessionStorage(LOT_NEXT_PREV_KEY) || {};

      search.md5 = md5;
      search.page = md5Page;

      if (!search.lots) search.lots = {};
      if (!search.lots[md5]) search.lots = {};
      if (!search.lots[md5]) search.lots[md5] = { items: {}, query: md5Query, pathname: window.location.pathname };
      if (!search.lots[md5].items[md5Page]) search.lots[md5].items[md5Page] = [];

      idlots.forEach(id => {
        if (isEmpty(search.lots[md5].items[md5Page].filter(l => l.id === id))) {
          search.lots[md5].items[md5Page].push({ id, url: lots[id].url, md5Page });
        }
      });

      setSessionStorage(LOT_NEXT_PREV_KEY, search);
    }
  }, [lots, idlots]);

  if (isEmpty(idlots) && isEmpty(ails))
    return (
      <div className="row">
        <div className="col-xs-12">
          <h2 className="text-center marg marg-t-50 marg-b-50">
            <A18n rsx="artprice.Bio.Glossary.m8" />
          </h2>
        </div>
      </div>
    );

  return (
    <div className={classNames(['lots-list', access ? `lots-${lotsViewFormat}` : 'lots-square'])}>
      {ails?.map((id, position) => (
        <Tile reloadDocument={reloadDocument} key={id} id={id} analyticClickFrom={analyticClickFrom} position={position} format={lotsViewFormat} isAil withSelectLot={withSelectLot} />
      ))}
      {idlots.map((id, position) => (
        <Tile key={id} reloadDocument={reloadDocument} id={id} analyticClickFrom={analyticClickFrom} position={position} format={lotsViewFormat} withSelectLot={withSelectLot} />
      ))}
    </div>
  );
};

export default List;
